// Creates custom icon mapping for Quasar
export default (iconName = '') => ({
  cls: `mi-icon-${ iconName }`
})
